import { render, staticRenderFns } from "./status-form.vue?vue&type=template&id=6366a703&scoped=true"
import script from "./status-form.vue?vue&type=script&lang=js"
export * from "./status-form.vue?vue&type=script&lang=js"
import style0 from "./status-form.vue?vue&type=style&index=0&id=6366a703&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366a703",
  null
  
)

export default component.exports